const getters = {
    getDiseases: state => state.diseases
}

export default getters